import { render } from "./Game.vue?vue&type=template&id=4f3308bb"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"
script.render = render

export default script